import React from 'react';
import { useIsMutating } from 'react-query';
import { FORM_ID, MODAL_HEADER_ID } from './UnlinkAndDeleteModal.meta';
import { UnlinkAndDeleteModalForm } from './UnlinkAndDeleteModalForm';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { UNLINK_ORION_CONSUMER_MK } from '../../api/useUnlinkOrionConsumerMutation';

interface Props {
  onClose(): void;
}

export const UnlinkAndDeleteModal: React.FC<Props> = ({ onClose }) => {
  const isUnlinkingOrionConsumer = useIsMutating({ mutationKey: UNLINK_ORION_CONSUMER_MK }) > 0;

  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: MODAL_HEADER_ID }} size="large">
      <ModalHeader id={MODAL_HEADER_ID}>
        Are you sure you want to unlink this household from Orion Connect?
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Text as="p">
          Unlinking this will remove the connection between the Orion Connect household entirely.
        </Text>

        <UnlinkAndDeleteModalForm />
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose} isLoading={isUnlinkingOrionConsumer}>
          Cancel
        </Button>

        <Button
          type="submit"
          ml="12"
          variant="error"
          isLoading={isUnlinkingOrionConsumer}
          form={FORM_ID}
        >
          Unlink
        </Button>
      </ModalFooter>
    </Modal>
  );
};
